module.exports = __webpack_public_path__ + "img/add_image.9578e953.svg";